import React, { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import RKTextField from "../../../../../Supporting files/RKTextField/RKTextField";
import SearchDropdown from "../../../../../Supporting files/SearchDropdown/SearchDropdown";
import Grid from "@mui/material/Unstable_Grid2";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import {
  Box,
  Button,
  FormControlLabel,
  Link,
  Modal,
  Radio,
  RadioGroup,
  Tooltip,
} from "@mui/material";
import DatePicker from "../../../../../Supporting files/DatePicker/DatePicker";
import SelectDropdown from "../../../../../Supporting files/SelectDropdown/SelectDropdown";
import "../../../../../formLayout.scss";
import Attachment from "../../../../../Components/Broker/Attachment/Attachment";
import NotesSection from "../../../../../Components/Broker/NotesSection/NotesSection";
import TasksSection from "../../../../../Components/Broker/TasksSection/TasksSection";
import EmailComponent from "../../../../../Components/Broker/EmailComponent/EmailComponent";
function NewEmployee() {
  const navigate = useNavigate();
  const [notesData, setNotesData] = useState<
    Array<{ name: string; date: Date; description: string }>
  >([]);

  const [proportion, setProportion] = React.useState("");
  const [Dob, setDob] = React.useState<Date | null>(new Date());
  const [nomineeDob, setNomineeDob] = React.useState<Date | null>(new Date());
  const [Doj, setDoj] = React.useState<Date | null>(null);
  const [viewTabsStatus, setViewTabsStatus] = React.useState("overview");
  const [openEmail, setOpenEmail] = React.useState(false);
  const [fullName, setFullName] = React.useState("");
  const [relationship, setRelationship] = React.useState("");
  const [nomineeName, setNomineeName] = React.useState("");
  const [nomineeAge, setNomineeAge] = React.useState("");
  const [organizationName, setOrganizationName] = React.useState("");
  const [orgNumber, setOrgNumber] = React.useState("");
  const [orgEmail, setOrgEmail] = React.useState("");
  const [personalemail, setPersonalEmail] = React.useState("");
  const [spoc, setSpoc] = React.useState("");
  const [phoneNumber, setPhoneNumber] = React.useState("");
  const [mobilenumber, setMobileNumber] = React.useState("");
  const [Currentjob, setCurrentJob] = React.useState("");
  const [Currentemployer, setCurrentEmployer] = React.useState("");
  const [title, setTitle] = React.useState("");
  const [firstName, setFirstName] = React.useState("");
  //   const [middleName, setMiddleName] = React.useState("");
  const [lastName, setLastName] = React.useState("");
  const [Department, setDepartment] = React.useState("");
  const [Designation, setDesignation] = React.useState("");
  const [gender, setGender] = React.useState("");
  const [personalMobile, setPersonalMobile] = React.useState("");
  const [buildingName, setBuildingName] = React.useState("");
  const [areaName, setAreaName] = React.useState("");
  const [country, setCountry] = React.useState("");
  const [State, setState] = React.useState("");
  const [numberofnominee, setNumberofnominee] = React.useState("");
  const [location, setLocation] = React.useState("");
  const [StateOrg, setStateOrg] = React.useState("");
  const [City, setCity] = React.useState("");
  const [CityOrg, setCityOrg] = React.useState("");
  const [Zipcode, setZipcode] = React.useState("");
  const [ZipcodeOrg, setZipcodeOrg] = React.useState("");
  const [industry, setIndustry] = React.useState("");
  const [streetName, setStreetName] = React.useState("");
  const [subindustry, setSubIndustry] = React.useState("");
  const [emailcomp, setEmailComp] = React.useState(false);
  const [deleteStatus, setDeleteStatus] = React.useState(false);
  const [removeStatus, setRemoveStatus] = React.useState(false);
  const [clientId, setClientId] = React.useState("");
  const [toggle, setToggle] = React.useState(true);
  const [uploadFile, setUploadFile] = React.useState(false);
  const [listViewStatus, setListViewStatus] = React.useState(true);
  const [expanded, setExpanded] = React.useState<string | false>("panel1");
  const [priorityStatus, setPriorityStatus] = React.useState("Pending");
  const [sectionStatus, SetSectionStatus] =
    React.useState<string>("personalDetails");
  const [subSection, setSubSection] = React.useState("basicinfo");
  const [postQueryForm, setPostQueryForm] = React.useState(false);
  const [attachment, setAttachment] = React.useState(false);
  const title_data = [
    { key: "Mr.", value: "Mr." },
    { key: "Mrs.", value: "Mrs." },
    { key: "Ms.", value: "Ms." },
  ];
  const nominees_data = [
    { key: "1", value: "1" },
    { key: "2", value: "2" },
  ];
  const relationship_data = [
    { key: "Brother", value: "Brother" },
    { key: "Sister", value: "Sister" },
    { key: "Spouse", value: "Spouse" },
    { key: "Husband", value: "Husband" },
    { key: "Father", value: "Father" },
    { key: "Daughter", value: "Daughter" },
    { key: "Son", value: "Son" },
  ];
  const clientId_data = [
    { label: "EV101", value: "EV101" },
    { label: "EV120", value: "EV120" },
    { label: "EV201", value: "EV201" },
  ];
  const gender_data = [
    { key: "Male", value: "Male" },
    { key: "Female", value: "Female" },
  ];

  const industry_data = [
    { label: "Engineering", value: "Engineering" },
    { label: "IT", value: "IT" },
    { label: "Human Resource", value: "Human Resource" },
    { label: "Business Development", value: "Business Development" },
    { label: "Designing", value: "Designing" },
    { label: "Management", value: "Management" },
  ];
  const subindustry_data = [
    { label: "Engineering", value: "Engineering" },
    { label: "IT", value: "IT" },
    { label: "Human Resource", value: "Human Resource" },
    { label: "Business Development", value: "Business Development" },
    { label: "Designing", value: "Designing" },
    { label: "Management", value: "Management" },
  ];
  const ClientIds_data = [
    { label: "CL 0001", value: "CL 0001" },
    { label: "CL 0002", value: "CL 0002" },
    { label: "CL 0003", value: "CL 0003" },
    { label: "CL 0004", value: "CL 0004" },
    { label: "CL 0005", value: "CL 0005" },
    { label: "CL 0006", value: "CL 0006" },
  ];
  const location_data = [
    { label: "Regiasted Office", value: "Regiasted Office" },
    { label: "Regional Office", value: "Regional Office" },
    { label: "State Head Office", value: "State Head Office" },
    { label: "City Office", value: "City Office" },
    { label: "City Sub Office", value: "City Sub Office" },
  ];

  const prioritystatusData = [
    { key: "Pending", value: "Pending" },
    { key: "Expired", value: "Expired" },
    { key: "Active", value: "Active" },
    { key: "Rejected", value: "Rejected" },
    { key: "Inprogress", value: "Inprogress" },
  ];
  const Department_data = [
    { label: "Engineering", value: "Engineering" },
    { label: "IT", value: "IT" },
    { label: "Human Resource", value: "Human Resource" },
    { label: "Business Development", value: "Business Development" },
    { label: "Designing", value: "Designing" },
    { label: "Management", value: "Management" },
  ];

  const country_data = [
    { label: "India", value: "India" },
    { label: "Australia", value: "Australia" },
    { label: "England", value: "England" },
    { label: "New Zealand", value: "New Zealand" },
    { label: " South Africa", value: "South Africa" },
  ];
  const Designation_data = [
    {
      label: "Associate Frontend Developer",
      value: "Associate Frontend Developer",
    },
    { label: "Frontend Developer", value: "Frontend Developer" },
    { label: "Senior Frontend Developer", value: "Senior Frontend Developer" },
    {
      label: "Associate Software Engineer",
      value: "Associate Software Engineer",
    },
    { label: "Software Engineer", value: "Software Engineer" },
    { label: "Associate Hr", value: "Associate Hr" },
    { label: "Hr Executive", value: "Hr Executive" },
  ];
  const state_data = [
    { label: "Rajasthan", value: "Rajasthan" },
    { label: "Punjab", value: "Punjab" },
    { label: "Haryana", value: "Haryana" },
    { label: "Kerla", value: "Kerla" },
    { label: "Delhi", value: "Delhi" },
  ];
  const nomineeAge_data = [
    { label: "25 Years", value: "25 Years" },
    { label: "26 Years", value: "26 Years" },
    { label: "27 Years", value: "27 Years" },
    { label: "28 Years", value: "28 Years" },
    { label: "29 Years", value: "29 Years" },
    { label: "30 Years", value: "30 Years" },
    { label: "31 Years", value: "31 Years" },
    { label: "32 Years", value: "32 Years" },
  ];
  const city_data = [
    { label: "Ambala", value: "Ambala" },
    { label: "Nanital", value: "Nanital" },
    { label: "Chandigarh", value: "Chandigarh" },
    { label: "Jaipur", value: "Jaipur" },
    { label: " New Delhi", value: "New Delhi" },
  ];
  const ClientId_data = [
    { label: "CL 0001", value: "CL 0001" },
    { label: "CL 0002", value: "CL 0002" },
    { label: "CL 0003", value: "CL 0003" },
    { label: "CL 0004", value: "CL 0004" },
    { label: "CL 0005", value: "CL 0005" },
    { label: "CL 0006", value: "CL 0006" },
  ];

  // for scrolling
  const personalDetails = useRef(null);
  const emaildetails = useRef(null);
  const attatchmentsdetails = useRef(null);
  const tododetails = useRef(null);
  const notes = useRef(null);
  const nominee = useRef(null);
  //const ref = useRef(null);
  const basicinfo = useRef(null);
  const professional = useRef(null);
  const addressdetails = useRef(null);
  //const personaladdress = useRef(null);

  const scrollToSection = (elementRef: any) => {
    // debugger;
    elementRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  const handleClicks = (ref: any) => {
    console.log("handle click", ref);
    ref.current?.scrollIntoView({ behavior: "smooth" });
  };

  //Table Data
  const [data, setData] = React.useState<
    Array<{
      title: string;
      title_class: string;
      data: Array<{
        open_status: boolean;
        title: string;
        status: string;
        due_date: string;
        priority: string;
        priority_class: string;
        linked_to: string;
        assignee: Array<string>;
        creation_date: string;
        creation_time: string;
        sub_data: Array<{
          title: string;
          status: string;
          due_date: string;
          priority: string;
          priority_class: string;
          linked_to: string;
          assignee: Array<string>;
          creation_date: string;
          creation_time: string;
        }>;
      }>;
    }>
  >([
    {
      title: "Started",
      title_class: "green",
      data: [
        {
          open_status: false,
          title: "Follow Up",
          status: "started",
          due_date: "31 Dec",
          priority: "High",
          priority_class: "high",
          linked_to: "Quotes-QT25",
          assignee: ["U", "R"],
          creation_date: "23 Dec",
          creation_time: "17:00",
          sub_data: [
            {
              title: "Second Call",
              status: "inqueue",
              due_date: "25 Nov",
              priority: "Highest",
              priority_class: "highest",
              linked_to: "Quotes-QT25",
              assignee: ["U", "R"],
              creation_date: "28 Dec",
              creation_time: "13:00",
            },
            {
              title: "Final Call",
              status: "completed",
              due_date: "20 Dec",
              priority: "Low",
              priority_class: "low",
              linked_to: "Quotes-QT28",
              assignee: ["U", "R"],
              creation_date: "20 Dec",
              creation_time: "15:00",
            },
            {
              title: "Follow Up",
              status: "inqueue",
              due_date: "31 Dec",
              priority: "Normal",
              priority_class: "normal",
              linked_to: "Quotes-QT24",
              assignee: ["U", "R"],
              creation_date: "26 Dec",
              creation_time: "19:00",
            },
          ],
        },
        {
          open_status: false,
          title: "Follow Up",
          status: "inqueue",
          due_date: "28 Dec",
          priority: "Low",
          priority_class: "low",
          linked_to: "Quotes-QT28",
          assignee: ["U", "R"],
          creation_date: "10 Dec",
          creation_time: "13:00",
          sub_data: [
            {
              title: "Second Call",
              status: "inqueue",
              due_date: "25 Nov",
              priority: "Highest",
              priority_class: "highest",
              linked_to: "Quotes-QT25",
              assignee: ["U", "R"],
              creation_date: "28 Dec",
              creation_time: "13:00",
            },
            {
              title: "Final Call",
              status: "completed",
              due_date: "20 Dec",
              priority: "Low",
              priority_class: "low",
              linked_to: "Quotes-QT28",
              assignee: ["U", "R"],
              creation_date: "20 Dec",
              creation_time: "15:00",
            },
            {
              title: "Follow Up",
              status: "inqueue",
              due_date: "31 Dec",
              priority: "Normal",
              priority_class: "normal",
              linked_to: "Quotes-QT24",
              assignee: ["U", "R"],
              creation_date: "26 Dec",
              creation_time: "19:00",
            },
          ],
        },
        {
          open_status: false,
          title: "Follow Up",
          status: "completed",
          due_date: "25 Dec",
          priority: "Highest",
          priority_class: "highest",
          linked_to: "Quotes-QT23",
          assignee: ["U", "R"],
          creation_date: "3 Dec",
          creation_time: "19:00",
          sub_data: [
            {
              title: "Second Call",
              status: "inqueue",
              due_date: "25 Nov",
              priority: "Highest",
              priority_class: "highest",
              linked_to: "Quotes-QT25",
              assignee: ["U", "R"],
              creation_date: "28 Dec",
              creation_time: "13:00",
            },
            {
              title: "Final Call",
              status: "completed",
              due_date: "20 Dec",
              priority: "Low",
              priority_class: "low",
              linked_to: "Quotes-QT28",
              assignee: ["U", "R"],
              creation_date: "20 Dec",
              creation_time: "15:00",
            },
            {
              title: "Follow Up",
              status: "inqueue",
              due_date: "31 Dec",
              priority: "Normal",
              priority_class: "normal",
              linked_to: "Quotes-QT24",
              assignee: ["U", "R"],
              creation_date: "26 Dec",
              creation_time: "19:00",
            },
          ],
        },
      ],
    },
  ]);

  const updateMasterState = (attrName: any, value: string) => {
    attrName(value);
  };

  const statusData = [
    { key: "started", value: "Started" },
    { key: "inqueue", value: "In Queue" },
    { key: "senttoinsurer", value: "Sent to Insurer" },
    { key: "upcomingrenewal", value: "Upcoming Renewal" },
    { key: "pendingwithinsurer", value: "Pending with Insurer" },
    { key: "endorsementrequestsent", value: "Endorsement Request Sent" },
    { key: "claimrequestsent", value: "Claim Request Sent" },
    { key: "completed", value: "Completed" },
  ];

  const handleClick = () => {
    setToggle(!toggle);
  };
  const handleChange =
    (panel: string) => (event: React.SyntheticEvent, isExpanded: boolean) => {
      setExpanded(isExpanded ? panel : false);
    };
  return (
    <Box className="layoutWrapper">
      {/* Page header */}
      <Grid container spacing={3} className="pageHeader">
        <Grid xs={6} className="pageTitle">
          <Link
            className="backStep"
            onClick={() => {
              navigate("/homeemployer?page=employee");
            }}
          >
            <ChevronLeftIcon />
          </Link>
          {/* <span className="detailIcon">A</span> */}
          <div>
            <h3>Add New Employee</h3>
          </div>
        </Grid>
        <Grid
          xs={6}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "end",
          }}
        ></Grid>
      </Grid>
      <Grid container spacing={3}>
        <Grid xs={12}>
          <Grid container spacing={3}>
            <Grid xs className="leftSection h-100">
              <Link
                className={
                  sectionStatus === "personalDetails"
                    ? "active sectionLink personalDetails"
                    : "sectionLink personalDetails"
                }
                onClick={() => {
                  scrollToSection(personalDetails);
                  SetSectionStatus("personalDetails");
                }}
              >
                <span> Personal Details</span>
              </Link>
              <ul className="accordion_list">
                <li>
                  <Link
                    className={
                      subSection === "basicinfo"
                        ? "inner_link active basicinfo"
                        : "inner_link basicinfo"
                    }
                    onClick={() => {
                      setSubSection("basicinfo");
                      handleClicks(subSection);
                      scrollToSection(basicinfo);
                    }}
                  >
                    Basic info
                  </Link>
                </li>
                <li>
                  <Link
                    className={
                      subSection === "professional"
                        ? "inner_link active professional"
                        : "inner_link professional"
                    }
                    onClick={() => {
                      setSubSection("professional");
                      handleClicks(subSection);
                      scrollToSection(professional);
                    }}
                  >
                    Professional Details
                  </Link>
                </li>
              </ul>

              <Link
                className={
                  sectionStatus === "addressdetails"
                    ? "active sectionLink addressdetails"
                    : "sectionLink addressdetails"
                }
                onClick={() => {
                  handleClicks(sectionStatus);
                  scrollToSection(addressdetails);
                  SetSectionStatus("addressdetails");
                }}
              >
                <span>Address Details</span>
              </Link>

              <Link
                className={
                  sectionStatus === "nominee"
                    ? "active sectionLink nominee"
                    : "sectionLink nominee"
                }
                onClick={() => {
                  scrollToSection(nominee);
                  SetSectionStatus("nominee");
                }}
              >
                <span>Nominee</span>
              </Link>

              {/* <Link
                className={
                  sectionStatus === "emaildetails"
                    ? "active sectionLink emaildetails"
                    : "sectionLink emaildetails"
                }
                onClick={() => {
                  scrollToSection(emaildetails);
                  SetSectionStatus("emaildetails");
                }}>
                <span>Emails</span>
              </Link> */}

              <Link
                className={
                  sectionStatus === "attatchmentsdetails"
                    ? "active sectionLink attatchmentsdetails"
                    : "sectionLink attatchmentsdetails"
                }
                onClick={() => {
                  handleClicks(sectionStatus);
                  scrollToSection(attatchmentsdetails);
                  SetSectionStatus("attatchmentsdetails");
                }}
              >
                <span>Attatchments</span>
              </Link>

              <Link
                className={
                  sectionStatus === "tododetails"
                    ? "active sectionLink tododetails"
                    : "sectionLink tododetails"
                }
                onClick={() => {
                  handleClicks(sectionStatus);
                  scrollToSection(tododetails);
                  SetSectionStatus("tododetails");
                }}
              >
                <span> Tasks</span>
              </Link>
              <Link
                className={
                  sectionStatus === "notes"
                    ? "active sectionLink notes"
                    : "sectionLink notes"
                }
                onClick={() => {
                  handleClicks(sectionStatus);
                  scrollToSection(notes);
                  SetSectionStatus("notes");
                }}
              >
                <span>Notes</span>
              </Link>
            </Grid>
            <Grid xs className="rightSection h-100">
              {viewTabsStatus == "overview" ? (
                <>
                  <Box className="detailSection" ref={personalDetails}>
                    <div className="sectionTitle">
                      <h4>Personal Details</h4>
                    </div>
                    <div ref={basicinfo}>
                      <Grid container spacing={3}>
                        <Grid xs={12}>
                          <h5 className="subHeading">Basic info</h5>
                        </Grid>
                      </Grid>
                      <Grid container spacing={3}>
                        <Grid sm={4} md={4} lg={3} xl={2}>
                          <RKTextField
                            class_name="inputField"
                            title="First Name"
                            value={firstName}
                            attrName={setFirstName}
                            value_update={updateMasterState}
                            warn_status={false}
                          />
                        </Grid>
                        {/* <Grid sm={4} md={4} lg={3} xl={2}>
                          <RKTextField
                            class_name="inputField"
                            title="Middle Name"
                            value={middleName}
                            attrName={setMiddleName}
                            value_update={updateMasterState}
                            warn_status={false}
                          />
                        </Grid> */}
                        <Grid sm={4} md={4} lg={3} xl={2}>
                          <RKTextField
                            class_name="inputField"
                            title="Last Name"
                            value={lastName}
                            attrName={setLastName}
                            value_update={updateMasterState}
                            warn_status={false}
                          />
                        </Grid>
                      </Grid>
                      <Grid container spacing={3}>
                        <Grid sm={4} md={4} lg={3} xl={2}>
                          <SelectDropdown
                            class_name="inputField"
                            title="Gender"
                            value={gender}
                            attrName={setGender}
                            value_update={updateMasterState}
                            dropdown_data={gender_data}
                            warn_status={false}
                          />
                        </Grid>
                        <Grid sm={4} md={4} lg={3} xl={2}>
                          <DatePicker
                            class_name="inputField"
                            title="Date of Birth"
                            value={Dob}
                            attrName={setDob}
                            value_update={updateMasterState}
                            error_message="Please enter Date of Birth"
                            warn_status={false}
                          />
                        </Grid>
                        <Grid sm={4} md={4} lg={3} xl={2}>
                          <RKTextField
                            class_name="inputField"
                            title="Contact Number"
                            value={mobilenumber}
                            attrName={setMobileNumber}
                            value_update={updateMasterState}
                            warn_status={false}
                          />
                        </Grid>
                      </Grid>
                      <Grid container spacing={3}>
                        <Grid sm={4} md={4} lg={3} xl={2}>
                          <RKTextField
                            class_name="inputField"
                            title="Email"
                            value={personalemail}
                            attrName={setPersonalEmail}
                            value_update={updateMasterState}
                            warn_status={false}
                          />
                        </Grid>
                      </Grid>
                    </div>

                    <div ref={professional}>
                      <Grid container spacing={3}>
                        <Grid xs={12}>
                          <h5 className="subHeading">Professional Details</h5>
                        </Grid>
                      </Grid>
                      <Grid container spacing={3}>
                        <Grid xs={6} md={5} lg={3} xl={2}>
                          <RKTextField
                            class_name="inputField"
                            title="Organization"
                            value={organizationName}
                            attrName={setOrganizationName}
                            value_update={updateMasterState}
                            warn_status={false}
                          />
                        </Grid>
                        <Grid xs={6} md={5} lg={3} xl={2}>
                          <SearchDropdown
                            class_name="inputField"
                            title="Location"
                            value={location}
                            attrName={setLocation}
                            value_update={updateMasterState}
                            data={location_data}
                            warn_status={false}
                            error_message="Please select client"
                          />
                        </Grid>
                      </Grid>
                      <Grid container spacing={3}>
                        <Grid sm={6} md={5} lg={3} xl={3}>
                          <SearchDropdown
                            class_name="inputField"
                            title="Department"
                            value={Department}
                            attrName={setDepartment}
                            value_update={updateMasterState}
                            data={Department_data}
                            warn_status={false}
                            error_message="Please select client"
                          />
                        </Grid>
                        <Grid sm={6} md={5} lg={3} xl={3}>
                          <SearchDropdown
                            class_name="inputField"
                            title="Designation"
                            value={Designation}
                            attrName={setDesignation}
                            value_update={updateMasterState}
                            data={Designation_data}
                            warn_status={false}
                            error_message="Please select client"
                          />
                        </Grid>
                      </Grid>
                      <Grid container spacing={3}>
                        <Grid sm={4} md={4} lg={3} xl={2}>
                          <DatePicker
                            class_name="inputField"
                            title="Date of Joining"
                            value={Doj}
                            attrName={setDoj}
                            value_update={updateMasterState}
                            error_message="Please enter Date of joining"
                            warn_status={false}
                          />
                        </Grid>
                        <Grid sm={4} md={4} lg={3} xl={2}>
                          <RKTextField
                            class_name="inputField"
                            title={"Office Email"}
                            value={orgEmail}
                            attrName={setOrgEmail}
                            value_update={updateMasterState}
                            warn_status={false}
                          />
                        </Grid>
                        <Grid sm={4} md={4} lg={3} xl={2}>
                          <RKTextField
                            class_name="inputField"
                            title={"Office Contact Number"}
                            value={orgNumber}
                            attrName={setOrgNumber}
                            value_update={updateMasterState}
                            warn_status={false}
                          />
                        </Grid>
                      </Grid>
                    </div>
                  </Box>
                  <Box className="detailSection" ref={addressdetails}>
                    <div className="sectionTitle">
                      <h4>Personal Address Details</h4>
                    </div>

                    <div>
                      <Grid container spacing={3}>
                        <Grid xs={12}>
                          <h5 className="subHeading">
                            Personal Address Details
                          </h5>
                        </Grid>
                      </Grid>
                      <Grid container spacing={3}>
                        <Grid sm={6} md={5} lg={4}>
                          <RKTextField
                            class_name="inputField"
                            title="Building/Street Name"
                            value={buildingName}
                            attrName={setBuildingName}
                            value_update={updateMasterState}
                            warn_status={false}
                          />
                        </Grid>
                        <Grid sm={6} md={5} lg={4}>
                          <RKTextField
                            class_name="inputField"
                            title="Area Name"
                            value={areaName}
                            attrName={setAreaName}
                            value_update={updateMasterState}
                            warn_status={false}
                          />
                        </Grid>
                      </Grid>
                      <Grid container spacing={3}>
                        <Grid sm={6} md={4} lg={3} xl={3}>
                          <SearchDropdown
                            class_name="inputField"
                            title="Country"
                            value={country}
                            attrName={setCountry}
                            value_update={updateMasterState}
                            data={country_data}
                            warn_status={false}
                            error_message="Please select client"
                          />
                        </Grid>
                        <Grid sm={6} md={4} lg={3} xl={3}>
                          <SearchDropdown
                            class_name="inputField"
                            title="State"
                            value={State}
                            attrName={setState}
                            value_update={updateMasterState}
                            data={state_data}
                            warn_status={false}
                            error_message="Please select client"
                          />
                        </Grid>
                        <Grid sm={6} md={4} lg={3} xl={3}>
                          <SearchDropdown
                            class_name="inputField"
                            title="City"
                            value={City}
                            attrName={setCity}
                            value_update={updateMasterState}
                            data={city_data}
                            warn_status={false}
                            error_message="Please select client"
                          />
                        </Grid>
                        <Grid sm={6} md={4} lg={3} xl={3}>
                          <RKTextField
                            class_name="inputField"
                            title={"Zipcode"}
                            value={Zipcode}
                            attrName={setZipcode}
                            value_update={updateMasterState}
                            warn_status={false}
                          />
                        </Grid>
                      </Grid>
                    </div>
                  </Box>
                  <Box className="detailSection" ref={nominee}>
                    <div className="sectionTitle">
                      <h4>Nominee</h4>
                    </div>
                    <div>
                      <Grid container spacing={3}>
                        <Grid xs={12}>
                          <h5 className="subHeading">Nominee Details</h5>
                        </Grid>
                      </Grid>
                      <Grid container spacing={3}>
                        <Grid
                          sm={4}
                          md={3}
                          lg={3}
                          xl={2}
                          className="switchFields switchheight"
                          display={"flex"}
                          alignItems="center"
                        >
                          <span>Add Nominee</span>
                          <input
                            type="checkbox"
                            className="switch"
                            onClick={handleClick}
                          />
                        </Grid>
                        {toggle == false ? (
                          <Grid xs={2}>
                            <SelectDropdown
                              class_name="inputField"
                              title="Number of Nominees"
                              value={numberofnominee}
                              attrName={setNumberofnominee}
                              value_update={updateMasterState}
                              dropdown_data={nominees_data}
                              warn_status={false}
                            />
                          </Grid>
                        ) : null}
                      </Grid>
                      {numberofnominee === "1" ? (
                        <>
                          <Grid container spacing={3}>
                            <Grid xs={12}>
                              <h5 className="subHeading">Nominee 1</h5>
                            </Grid>
                          </Grid>
                          <Grid container spacing={3}>
                            <Grid sm={6} md={4} lg={3} xl={3}>
                              <RKTextField
                                class_name="inputField"
                                title="Full Name"
                                value={nomineeName}
                                attrName={setNomineeName}
                                value_update={updateMasterState}
                                warn_status={false}
                              />
                            </Grid>
                            <Grid sm={6} md={4} lg={3} xl={3}>
                              <SelectDropdown
                                class_name="inputField"
                                title="Relationship with Employee"
                                value={relationship}
                                attrName={setRelationship}
                                value_update={updateMasterState}
                                dropdown_data={relationship_data}
                                warn_status={false}
                              />
                            </Grid>
                            <Grid sm={6} md={4} lg={3} xl={3}>
                              <DatePicker
                                class_name="inputField"
                                title="Date of Birth"
                                value={nomineeDob}
                                attrName={setNomineeDob}
                                value_update={updateMasterState}
                                error_message="Please enter Date of Birth"
                                warn_status={false}
                              />
                            </Grid>
                          </Grid>
                          <Grid container spacing={3}>
                            <Grid sm={6} md={6} lg={6} xl={6}>
                              <SearchDropdown
                                class_name="inputField"
                                title="Age"
                                value={nomineeAge}
                                attrName={setNomineeAge}
                                value_update={updateMasterState}
                                data={nomineeAge_data}
                                warn_status={false}
                                error_message="Please select client"
                              />
                            </Grid>
                            <Grid sm={6} md={6} lg={6} xl={6}>
                              <RKTextField
                                class_name="inputField"
                                title={"Proportion percentage for amount"}
                                value={proportion}
                                attrName={setProportion}
                                value_update={updateMasterState}
                                warn_status={false}
                              />
                            </Grid>
                          </Grid>
                        </>
                      ) : null}
                      {numberofnominee === "2" ? (
                        <>
                          <Grid container spacing={3}>
                            <Grid xs={12}>
                              <h5 className="subHeading">Nominee 1</h5>
                            </Grid>
                          </Grid>
                          <Grid container spacing={3}>
                            <Grid sm={6} md={4} lg={3} xl={3}>
                              <RKTextField
                                class_name="inputField"
                                title="Full Name"
                                value={nomineeName}
                                attrName={setNomineeName}
                                value_update={updateMasterState}
                                warn_status={false}
                              />
                            </Grid>
                            <Grid sm={6} md={4} lg={3} xl={3}>
                              <SelectDropdown
                                class_name="inputField"
                                title="Relationship with Employee"
                                value={relationship}
                                attrName={setRelationship}
                                value_update={updateMasterState}
                                dropdown_data={relationship_data}
                                warn_status={false}
                              />
                            </Grid>
                            <Grid sm={6} md={4} lg={3} xl={3}>
                              <DatePicker
                                class_name="inputField"
                                title="Date of Birth"
                                value={nomineeDob}
                                attrName={setNomineeDob}
                                value_update={updateMasterState}
                                error_message="Please enter Date of Birth"
                                warn_status={false}
                              />
                            </Grid>
                          </Grid>
                          <Grid container spacing={3}>
                            <Grid sm={6} md={6} lg={6} xl={6}>
                              <SearchDropdown
                                class_name="inputField"
                                title="Age"
                                value={nomineeAge}
                                attrName={setNomineeAge}
                                value_update={updateMasterState}
                                data={nomineeAge_data}
                                warn_status={false}
                                error_message="Please select client"
                              />
                            </Grid>
                            <Grid sm={6} md={6} lg={6} xl={6}>
                              <RKTextField
                                class_name="inputField"
                                title={"Proportion percentage for amount"}
                                value={proportion}
                                attrName={setProportion}
                                value_update={updateMasterState}
                                warn_status={false}
                              />
                            </Grid>
                          </Grid>
                          <Grid container spacing={3}>
                            <Grid xs={12}>
                              <h5 className="subHeading">Nominee 2</h5>
                            </Grid>
                          </Grid>
                          <Grid container spacing={3}>
                            <Grid sm={6} md={4} lg={3} xl={3}>
                              <RKTextField
                                class_name="inputField"
                                title="Full Name"
                                value={nomineeName}
                                attrName={setNomineeName}
                                value_update={updateMasterState}
                                warn_status={false}
                              />
                            </Grid>
                            <Grid sm={6} md={4} lg={3} xl={3}>
                              <SelectDropdown
                                class_name="inputField"
                                title="Relationship with Employee"
                                value={relationship}
                                attrName={setRelationship}
                                value_update={updateMasterState}
                                dropdown_data={relationship_data}
                                warn_status={false}
                              />
                            </Grid>
                            <Grid sm={6} md={4} lg={3} xl={3}>
                              <DatePicker
                                class_name="inputField"
                                title="Date of Birth"
                                value={nomineeDob}
                                attrName={setNomineeDob}
                                value_update={updateMasterState}
                                error_message="Please enter Date of Birth"
                                warn_status={false}
                              />
                            </Grid>
                          </Grid>
                          <Grid container spacing={3}>
                            <Grid sm={6} md={6} lg={6} xl={6}>
                              <SearchDropdown
                                class_name="inputField"
                                title="Age"
                                value={nomineeAge}
                                attrName={setNomineeAge}
                                value_update={updateMasterState}
                                data={nomineeAge_data}
                                warn_status={false}
                                error_message="Please select client"
                              />
                            </Grid>
                            <Grid sm={6} md={6} lg={6} xl={6}>
                              <RKTextField
                                class_name="inputField"
                                title={"Proportion percentage for amount"}
                                value={proportion}
                                attrName={setProportion}
                                value_update={updateMasterState}
                                warn_status={false}
                              />
                            </Grid>
                          </Grid>
                        </>
                      ) : null}
                    </div>
                  </Box>
                  {/* we have hide this section for phase 2 */}
                  <Box className="detailSection" ref={emaildetails}>
                    <div className="sectionTitle">
                      <h4>Emails </h4>
                      <div className="actionBtns">
                        <Link
                          className="redBtn delete"
                          sx={{ textDecoration: "none", cursor: "pointer" }}
                        >
                          Delete
                        </Link>

                        <Link
                          className="blueBtn edit"
                          sx={{ textDecoration: "none", cursor: "pointer" }}
                        >
                          Compose
                        </Link>
                      </div>
                    </div>

                    <EmailComponent
                      open_status={emailcomp}
                      attrName={setEmailComp}
                      value_update={updateMasterState}
                    />
                  </Box>
                  <Box className="detailSection" ref={attatchmentsdetails}>
                    <div className="sectionTitle">
                      <h4>Attachments </h4>

                      <div className="actionBtns">
                        <Link
                          className="blueBtn addfile"
                          sx={{ textDecoration: "none", cursor: "pointer" }}
                          onClick={() => setUploadFile(true)}
                        >
                          Add Document
                        </Link>
                      </div>
                    </div>
                    <Attachment
                      open_status={attachment}
                      attrName={setAttachment}
                      value_update={updateMasterState}
                    />
                  </Box>
                  <Box className="detailSection" ref={tododetails}>
                    <div className="sectionTitle">
                      <h4>Tasks</h4>

                      <div className="actionBtns">
                        <Link
                          className="blueBtn addfile"
                          sx={{ textDecoration: "none", cursor: "pointer" }}
                        >
                          Add Task
                        </Link>
                      </div>
                    </div>
                    <Grid container spacing={3}>
                      <Grid xs={12}>
                        <TasksSection />
                      </Grid>
                    </Grid>
                  </Box>
                  <Box className="detailSection" ref={notes}>
                    <div className="sectionTitle">
                      <h4>Notes</h4>

                      <div className="actionBtns">
                        <Link
                          className="blueBtn addfile"
                          sx={{ textDecoration: "none", cursor: "pointer" }}
                          onClick={() => {
                            setPostQueryForm(true);
                          }}
                        >
                          Add Notes
                        </Link>
                      </div>
                    </div>

                    <NotesSection data={notesData} />
                  </Box>
                </>
              ) : null}
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
}
export default NewEmployee;
